import dayjs from 'dayjs'

// eslint-disable-next-line import/prefer-default-export
export const CREATE_CAMPAIGN_DEFAULT_ID = 'creating-new-campaign'
export const DEFAULT_CAMPAIGN_NAME = `Campaign ${dayjs().format('MMMM D, YYYY')}`
export const INSERT_INPUT_MAX_LENGTH = 500
export const CAMPAIGN_DEFAULT_MERGE_FIELDS = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  PHONE_NUMBER: 'Phone Number',
  EMAIL: 'Email',
}

export const DEFAULT_CAMPAIGN_QUESTION =
  "You don't need to ask any questions. Just be helpful and always ask if they have any questions they need help with."
export const CAMPAIGN_EXECUTION_INTERVAL_SECONDS = 10
export const CAMPAIGN_STATUS_REFETCH_INTERVAL = 5
